import React from 'react';
import clsx from 'clsx';
import type { CollectButtonSource } from '@soundxyz/utils/analytics';
import { MintComponent } from '@components/Song/MintComponents';
import { StandardModal } from '@components/main-components/modals/StandardModal';
import type { MintReferral } from '@context/mintReferral';
import { useModal } from '@context/modal';
import { CollectModalFragmentDoc, type FragmentType, getFragment, gql } from '@graphql/reactQuery';

/*#__PURE__*/ gql(/* GraphQL */ `
  fragment CollectModal on Release {
    id
    spotifyPresaveCampaign
    ...MintComponent
  }
`);

export const CollectModal = ({
  release,
  mintReferral,
  collectButtonSource,
  TEMPORARY_showCustomPrice,
}: {
  release: FragmentType<CollectModalFragmentDoc>;
  collectButtonSource: CollectButtonSource;
  mintReferral: MintReferral | null;
  /**
   * DO NOT USE THIS PROP UNLESS YOU KNOW WHAT YOU ARE DOING
   * This is a temporary prop to hide the price for the tiers mint component
   * and show a custom price for the coinbase quest
   * Since there we are showing users the Sound Fee and showing them "Free" would be confusing
   * This prop should be removed once we have a better solution
   */
  TEMPORARY_showCustomPrice?: string;
}) => {
  const { closeCancelModal } = useModal();
  const releaseData = getFragment(CollectModalFragmentDoc, release);

  const body = (
    <div
      className={clsx(
        "flex justify-center [&>div>div>div]:overflow-visible [&>div]:mt-0 [&>div]:w-full [&_[dir='ltr']]:p-0 [&_[role='tabpanel']]:w-[unset]",
        'mb-1',
      )}
    >
      <MintComponent
        releaseData={releaseData}
        collectButtonSource={collectButtonSource}
        referral={mintReferral}
        isInModal
        TEMPORARY_showCustomPrice={TEMPORARY_showCustomPrice}
      />
    </div>
  );

  return (
    <StandardModal
      body={body}
      title="Collect"
      showHeaderShadow={false}
      closeModal={closeCancelModal}
      size="small"
      bodyWithoutPaddingBottom
    />
  );
};
